export default __webpack_public_path__ + "static/media/logo.0b5725f7.png";